import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminOrderTravelPurchase.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminOrderTravelPurchase' */ './component')],
	render: ([AdminOrderTravelPurchase]) => <AdminOrderTravelPurchase />,
};

export default routes;
